import Moment from 'moment';
import { withExpandedProductKeysInFilter } from '../utility/filter.expansions';
import {
  commonDateParamMappings,
  filterParamMapping,
} from '../api/common/mappings';
import { trimAndAddAsterisk } from '../utility/QueryUtility';

const commonAccountMappings = [{ path: 'page' }, { path: 'size' }];

export const accountServiceMappings = [
  ...commonAccountMappings,
  {
    path: 'from',
    paramKey: 'after',
    transform: ({ from, to }: any) => {
      if (!from) {
        return null;
      }

      return from === to
        ? Moment.unix(from).startOf('day').toISOString()
        : Moment.unix(from).toISOString();
    },
  },
  {
    path: 'to',
    paramKey: 'before',
    transform: ({ to, from }: any) => {
      if (!to) {
        return null;
      }

      return from === to
        ? Moment.unix(to).endOf('day').toISOString()
        : Moment.unix(to).toISOString();
    },
  },
  // {
  //   path: 'pageIndex',
  //   paramKey: 'page',
  //   transform: ({ pageIndex }) => {
  //     return isNaN(pageIndex) ? 0 : pageIndex;
  //   },
  // },
  {
    path: 'tag',
  },
  { path: 'isRiskMgmtAccount' },
  {
    path: 'state',
  },
  {
    paramKey: 'sort',
    transform: ({
      orderBy,
      order,
      poolsAccountGroupSearchEnhancements,
    }: any) => {
      if (
        orderBy === 'accountGroupName' &&
        order &&
        poolsAccountGroupSearchEnhancements !== undefined
      ) {
        const sortField = poolsAccountGroupSearchEnhancements
          ? 'accountGroupName'
          : 'group';
        return `${sortField}.keyword,${order}`;
      }

      switch (orderBy) {
        case 'revenue':
        case 'quickQuotePremium':
        case 'naicsCode':
        case 'noOfEmployeesAll':
        case 'yearEstablished':
        case 'created':
        case 'modified':
        case 'effectiveDate':
        case 'otherPolicyRenewalDate':
        case 'policyId':
        case 'naics':
        case 'isOpenForRenewal':
        case 'riskMgmtDetails.riskMgmtPriority.value':
        case 'riskMgmtDetails.riskMgmtDeadline':
          if (orderBy && order) {
            return `${orderBy},${order}`;
          }
          break;
        case 'timestamp':
          if (orderBy && order) {
            return `created,${order}`;
          }
          break;
        default:
          if (orderBy && order) {
            return `${orderBy}.keyword,${order}`;
          }
          return null;
      }
    },
  },
  {
    path: 'search',
    transform: ({ search, searchValue }: any) => {
      if (searchValue) {
        return searchValue;
      }
      return search ? trimAndAddAsterisk(search) : null;
    },
  },
  { path: 'fav' },

  // Service Mappings for search fields
  {
    path: 'name',
  },
  {
    path: 'description',
  },
  {
    path: 'domain',
  },
  {
    path: 'location',
  },
  { path: 'naicsCode' },
  { path: 'state' },
  { path: 'status' },
  { path: 'teamIds' },
  { path: 'isAgency' },
  { path: 'agentEmail' },
  { path: 'country' },
  {
    path: 'f',
    paramKey: 'filter',
    transform: ({ f, poolsAccountGroupSearchEnhancements }: any) => {
      if (!f) {
        return null;
      }

      if (
        poolsAccountGroupSearchEnhancements === undefined ||
        poolsAccountGroupSearchEnhancements === true ||
        f.accountGroupName === undefined
      ) {
        return withExpandedProductKeysInFilter(f);
      }

      const { accountGroupName, ...rest } = f;
      return withExpandedProductKeysInFilter({
        ...rest,
        group: accountGroupName,
      });
    },
  },
];

export const accountSearchV2Mappings = [
  ...commonDateParamMappings,
  ...commonAccountMappings,
  {
    paramKey: 'sort',
    transform: ({ orderBy, order }: any) => {
      if (orderBy && order) {
        return `${orderBy},${order}`;
      }
      return null;
    },
  },
  { path: 'search' },
  { path: 'accountId' },
  filterParamMapping,
  { path: 'teamIds' },
  { path: 'allAgencyResults' },
  { path: 'quoteFilter' },
  { path: 'binderFilter' },
  { path: 'policyFilter' },
];

export const accountAndNadSearchMappings = [
  ...commonAccountMappings,
  { path: 'search' },
  { path: 'state' },
  { path: 'country' },
];
